import React from "react";
import {
  Paper,
  Button,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Card,
  CardContent,
  Typography,
} from "@mui/material";

const NotificationsDetail = ({ focusedNotification, setCurrentPage }) => {
  return (
    <Paper
      elevation={4}
      sx={{
        py: 2,
        px: { xs: 1, sm: 10, md: 20, lg: 30, xl: 55 },
        minHeight: "100vh",
        bgcolor: "#e2e2e2",
      }}
    >
      <Button
        color="primary"
        variant="contained"
        onClick={() => setCurrentPage("list")}
        size="large"
        sx={{ mt: 1 }}
      >
        BACK
      </Button>
      <Button
        color="warning"
        variant="contained"
        onClick={() => setCurrentPage("edit")}
        size="large"
        sx={{ mt: 1, float: "right" }}
      >
        EDIT
      </Button>
      <Card elevation={6} sx={{ p: { xs: 0, sm: 4 }, mt: 3, mb: 3 }}>
        <CardContent>
          <Typography variant="h4" color="primary" sx={{ textAlign: "center" }}>
            NOTIFICATION DETAILS
          </Typography>
          <Table sx={{ mt: 3 }}>
            <TableBody
              sx={{
                border: "solid",
                borderWidth: "2px",
                borderColor: "#e2e2e2",
              }}
            >
              <TableRow>
                <TableCell
                  sx={{
                    bgcolor: "#2e68b1",
                    color: "#e2e2e2",
                    fontWeight: "bold",
                  }}
                >
                  NOTIFICATION TYPE
                </TableCell>
                <TableCell sx={{ textAlign: "center" }}>
                  {focusedNotification.notificationType}
                </TableCell>
              </TableRow>
              {focusedNotification.notificationType === "not pooled" && (
                <TableRow>
                  <TableCell
                    sx={{
                      bgcolor: "#2e68b1",
                      color: "#e2e2e2",
                      fontWeight: "bold",
                    }}
                  >
                    MOBILE ID
                  </TableCell>
                  <TableCell sx={{ textAlign: "center" }}>
                    {focusedNotification.MSISDN}
                  </TableCell>
                </TableRow>
              )}

              <TableRow>
                <TableCell
                  sx={{
                    bgcolor: "#2e68b1",
                    color: "#e2e2e2",
                    fontWeight: "bold",
                  }}
                >
                  NOTIFICATION SENT THIS MONTH
                </TableCell>
                <TableCell sx={{ textAlign: "center" }}>
                  {focusedNotification.notified ? "YES" : "NO"}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  sx={{
                    bgcolor: "#2e68b1",
                    color: "#e2e2e2",
                    fontWeight: "bold",
                  }}
                >
                  NOTIFICATION THRESHOLD
                </TableCell>
                <TableCell sx={{ textAlign: "center" }}>
                  {focusedNotification.threshold}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  sx={{
                    bgcolor: "#2e68b1",
                    color: "#e2e2e2",
                    fontWeight: "bold",
                  }}
                >
                  NOTIFICATION EMAIL ADDRESS
                </TableCell>
                <TableCell sx={{ textAlign: "center" }}>
                  {focusedNotification.emailAddress}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  sx={{
                    bgcolor: "#2e68b1",
                    color: "#e2e2e2",
                    fontWeight: "bold",
                  }}
                >
                  AB&T TELECOM ACCOUNT #
                </TableCell>
                <TableCell
                  sx={{
                    textAlign: "center",
                    color: "green",
                    fontWeight: "bold",
                  }}
                >
                  {focusedNotification.notificationAcctNum}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  sx={{
                    bgcolor: "#2e68b1",
                    color: "#e2e2e2",
                    fontWeight: "bold",
                  }}
                >
                  RATE PLAN CODE
                </TableCell>
                <TableCell
                  sx={{
                    textAlign: "center",
                  }}
                >
                  {focusedNotification.ratePlanCode}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </Paper>
  );
};

export default NotificationsDetail;
